/* eslint-disable max-classes-per-file */
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import '@scss/components/_modal.scss';

class Modal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isShow, id, children } = this.props;
    return (
      <>
        <div
          className={`modal fade ${isShow ? 'show d-block' : ''}`}
          id={id || ''}
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden={isShow ? 'false' : 'true'}
        >
          <div className="modal-dialog modal-dialog-centered modal__dialog">
            <div className="modal-content">
              {children}
            </div>
          </div>
        </div>
      </>
    );
  }
}

class ModalHeader extends Component {
  constructor(props) {
    super(props);
    this.handleClose = undefined !== this.props.handleModalShown ? this.props.handleModalShown : this.handleClose.bind(this);
  }

  handleClose() {

  }

  render() {
    return (
      <div className="modal-header">
        {this.props.children}
        <button type="button" className="btn-close" onClick={this.handleClose} />
      </div>
    );
  }
}

class ModalBody extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="modal-body">
        {this.props.children}
      </div>
    );
  }
}

class ModalFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="modal-footer">
        {this.props.children}
      </div>
    );
  }
}

Modal.propTypes = {
  id: PropTypes.string,
  isShow: PropTypes.bool,
};

ModalHeader.propTypes = {
  handleModalShown: PropTypes.func,
};

export {
  Modal, ModalHeader, ModalBody, ModalFooter,
};
